module.exports = __webpack_public_path__ + "static/media/geelong.ec66df84.svg";